import { render } from "./ItemsLabelScanner.vue?vue&type=template&id=91841eb8"
import script from "./ItemsLabelScanner.vue?vue&type=script&lang=js"
export * from "./ItemsLabelScanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__